import { normalizeWeightSectionForCompare } from './RubricWeights/rubricWeightsUtils';

function normalizeText(value) {
  return String(value ?? '').trim();
}

function normalizeWeight(value) {
  if (value === '' || value == null) {
    return null;
  }
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : normalizeText(value);
}

function normalizeSource(source) {
  return {
    assessment_key: normalizeText(source?.assessment_key),
    assessment_name: normalizeText(source?.assessment_name),
    question_set_key: normalizeText(source?.question_set_key),
    key: normalizeText(source?.key),
    question_text: normalizeText(source?.question_text),
  };
}

function normalizeQuestion(question) {
  return {
    key: normalizeText(question?.key),
    text: normalizeText(question?.text),
    weight: normalizeWeight(question?.weight),
    sources: Array.isArray(question?.sources)
      ? question.sources.map(normalizeSource)
      : [],
  };
}

function normalizeQuestionSet(questionSet) {
  return {
    key: normalizeText(questionSet?.key),
    name: normalizeText(questionSet?.name),
    weight: normalizeWeight(questionSet?.weight),
    questions: Array.isArray(questionSet?.questions)
      ? questionSet.questions.map(normalizeQuestion)
      : [],
  };
}

export function isPlainDocumentObject(document) {
  return (
    typeof document === 'object' &&
    document !== null &&
    !Array.isArray(document)
  );
}

export function normalizeRubricDocumentForDirtyCheck(document) {
  if (!isPlainDocumentObject(document)) {
    return {
      question_sets: [],
      weight_overrides: [],
    };
  }

  return {
    question_sets: Array.isArray(document.question_sets)
      ? document.question_sets.map(normalizeQuestionSet)
      : [],
    excluded_breakout_ids: Array.isArray(document.excluded_breakout_ids)
      ? [...document.excluded_breakout_ids].map(String).sort()
      : [],
    weight_overrides:
      normalizeWeightSectionForCompare(document).weight_overrides,
  };
}
